import { Box, Flex, Img, Text } from '@chakra-ui/react'
import { DotLottiePlayer } from '@dotlottie/react-player'
import React from 'react'

import { borderVariant10 } from '@/chakraTheme.js'

import CategoriesSelector from './CategoriesSelector.jsx'
import OptionsSelector from './OptionsSelector.jsx'

const EmojiSelector = ({
    emojiData,
    selectedEmojiData,
    hasCategories,
    selectedEmoji,
    hoveredEmoji,
    selectedCategories,
    selectedOptions,
    setSelectedEmoji,
    setHoveredEmoji,
    setSelectedCategories,
    setSelectedOptions,
}) => {
    return (
        <>
            <Box display="flex" flexDirection="column" mt={4}>
                <Box display="flex" justifyContent="center" gap={6} mt={4}>
                    {emojiData.map(emoji => (
                        <Box
                            key={emoji.name}
                            position="relative"
                            onMouseEnter={() => setHoveredEmoji(emoji.name)}
                            onMouseLeave={() => setHoveredEmoji(null)}
                            mt={selectedEmoji ? 0 : 12}
                        >
                            <Box
                                padding={selectedEmoji ? 3 : 4}
                                width={selectedEmoji ? '72px' : 24}
                                height={selectedEmoji ? '72px' : 24}
                                border={
                                    selectedEmoji === emoji.name ||
                                    hoveredEmoji === emoji.name
                                        ? emoji.border
                                        : borderVariant10
                                }
                                backgroundColor={
                                    selectedEmoji === emoji.name ||
                                    hoveredEmoji === emoji.name
                                        ? emoji.bgColor
                                        : 'transparent'
                                }
                                onClick={() => {
                                    setSelectedEmoji(emoji.name)
                                    setSelectedCategories([])
                                    setSelectedOptions([])
                                }}
                                transition="all 0.3s ease"
                                cursor="pointer"
                            >
                                {selectedEmoji === emoji.name ||
                                hoveredEmoji === emoji.name ? (
                                    <DotLottiePlayer
                                        src={emoji.animationSrc}
                                        autoplay
                                        speed={1.5}
                                        loop
                                    />
                                ) : (
                                    <Img src={emoji.emojiSrc} />
                                )}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>

            {selectedEmoji && (
                <Box
                    display="flex"
                    textAlign="center"
                    flexDirection="column"
                    maxWidth="95%"
                    justifyContent="center"
                    alignItems="center"
                    margin="0 auto"
                    mt={6}
                    fontFamily="Roboto"
                    height="100%"
                >
                    <Text
                        fontSize="sm"
                        fontFamily="Roboto"
                        lineHeight={6}
                        fontWeight={700}
                    >
                        {selectedEmojiData.question}
                    </Text>
                    <Text fontSize="xs" lineHeight={4} color="gray">
                        {selectedEmojiData.questionSubtext}
                    </Text>

                    {hasCategories ? (
                        // categories flow
                        <>
                            <CategoriesSelector
                                emojiData={emojiData}
                                selectedEmoji={selectedEmoji}
                                selectedCategories={selectedCategories}
                                setSelectedCategories={setSelectedCategories}
                            />

                            {selectedCategories.length > 0 && (
                                <Flex
                                    flexDirection="column"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="90%"
                                    opacity={selectedCategories.length ? 1 : 0}
                                    transition={'all 0.3s ease'}
                                >
                                    <OptionsSelector
                                        mode="CATEGORIES"
                                        emojiData={emojiData}
                                        selectedEmoji={selectedEmoji}
                                        selectedCategories={selectedCategories}
                                        selectedOptions={selectedOptions}
                                        setSelectedOptions={setSelectedOptions}
                                    />
                                </Flex>
                            )}
                        </>
                    ) : (
                        // options flow
                        <Flex
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            height="90%"
                            transition={'all 0.3s ease'}
                            paddingX={4}
                            paddingY={3}
                            mt={3}
                        >
                            <OptionsSelector
                                mode="OPTIONS"
                                emojiData={emojiData}
                                options={selectedEmojiData.options}
                                selectedOptions={selectedOptions}
                                setSelectedOptions={setSelectedOptions}
                            />
                        </Flex>
                    )}
                </Box>
            )}
        </>
    )
}

export default EmojiSelector
